'use client';

import { motion } from 'framer-motion';
import { HelpCircle, Award, Shield, RefreshCw } from 'lucide-react';

export function ServicesInfoSection() {
  return (
    <section className="relative py-16 bg-white w-full overflow-x-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 bg-[url('/grid-pattern.svg')] bg-repeat opacity-[0.03]" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Support */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="text-center p-6 rounded-xl bg-white border border-neutral-200 shadow-sm h-[250px] flex flex-col">
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full  text-black">
                <HelpCircle className="h-10 w-10" />
              </div>
              <h3 className="text-lg font-semibold text-black mb-2">Dedicated Support</h3>
              <p className="text-neutral-600">Expert assistance when you need it. Check out our comprehensive FAQ for immediate help.</p>
            </div>
          </motion.div>

          {/* Quality */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="text-center p-6 rounded-xl bg-white border border-neutral-200 shadow-sm h-[250px] flex flex-col">
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full  text-black">
                <Award className="h-10 w-10" />
              </div>
              <h3 className="text-lg font-semibold text-black mb-2">Premium Quality</h3>
              <p className="text-neutral-600">Exceptional craftsmanship with premium materials. Proudly designed and manufactured in the UK.</p>
            </div>
          </motion.div>

          {/* Safe & Secure */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="text-center p-6 rounded-xl bg-white border border-neutral-200 shadow-sm h-[250px] flex flex-col">
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full  text-black">
                <Shield className="h-10 w-10" />
              </div>
              <h3 className="text-lg font-semibold text-black mb-2">Safe & Secure</h3>
              <p className="text-neutral-600">Advanced encryption and strict data protection protocols ensure your information remains secure.</p>
            </div>
          </motion.div>

          {/* Refunds */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="text-center p-6 rounded-xl bg-white border border-neutral-200 shadow-sm h-[250px] flex flex-col">
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full  text-black">
                <RefreshCw className="h-10 w-10" />
              </div>
              <h3 className="text-lg font-semibold text-black mb-2">Hassle-Free Returns</h3>
              <p className="text-neutral-600">Simple, straightforward return policy with complimentary refunds on all non-personalized items.</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
